import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, TextField, Typography } from "@mui/material";

const PurchaseDateField = ({
  purchaseDateFrom,
  setPurchaseDateFrom,
  purchaseDateTo,
  setPurchaseDateTo,
}: {
  purchaseDateFrom: string;
  setPurchaseDateFrom: React.Dispatch<React.SetStateAction<string>>;
  purchaseDateTo: string;
  setPurchaseDateTo: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <TextField
        type="date"
        size="small"
        value={purchaseDateFrom}
        onChange={(e) => setPurchaseDateFrom(e.target.value)}
        sx={{ width: 180 }}
        InputLabelProps={{ shrink: true }}
      />
      <Typography color="primary">～</Typography>
      <TextField
        type="date"
        size="small"
        value={purchaseDateTo}
        onChange={(e) => setPurchaseDateTo(e.target.value)}
        sx={{ width: 180 }}
        InputLabelProps={{ shrink: true }}
      />
      <Typography color="primary">
        {t("quest_edit_target.label.not_specified.note_all_period")}
      </Typography>
    </Stack>
  );
};

export default PurchaseDateField;
